import { render, staticRenderFns } from "./SelectExtraReasons.vue?vue&type=template&id=38513ddf"
import script from "./SelectExtraReasons.vue?vue&type=script&lang=js"
export * from "./SelectExtraReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports